import React from 'react';

const Badge = ({ children, variant = 'default', className = '' }) => {
  const variants = {
    default: 'bg-sp-gray-800 text-gray-300 border-sp-gray-700',
    lime: 'bg-sp-lime-dim text-sp-lime border-sp-lime/30 shadow-neon',
    alert: 'bg-sp-alert/10 text-sp-alert border-sp-alert/30 shadow-neon-alert',
    cyan: 'bg-sp-cyan/10 text-sp-cyan border-sp-cyan/30',
  };

  return (
    <span className={`px-2 py-1 text-xs font-mono font-medium border rounded-md ${variants[variant]} ${className}`}>
      {children}
    </span>
  );
};

export default Badge;